import * as _ from 'lodash';

import { isTargetRoleId } from '../../utilities/roleUtility';
import {
  APPROVAL_STATUS,
  PREFECTURE_GROUPS,
  USER_ROLES,
} from '../../utilities/constants';

/**
 * 現場登録用のパラメータを作成する
 * stateオブジェクトの内部の値を変更する
 * @param {object}state
 * @param {number}roleId
 * @return {object}state
 * */
const createRegisterParams = (state, roleId) => {
  // 本店or支店管理者の場合承認、その他の場合は未承認
  if (isTargetRoleId([USER_ROLES.prime, USER_ROLES.branch], roleId)) {
    state.params.approval_flag = APPROVAL_STATUS.approval.id;
  } else {
    state.params.approval_flag = APPROVAL_STATUS.unapproved.id;
  }

  state.params.ccus_register_flg = state.ccus_register_flg;

  // 都道府県のカナを設定
  // 現場住所
  state.params.address_prefecture_kana = getPrefectureKana(
    state.params.address_prefecture
  );

  // 事務所住所のカナを設定
  state.params.office_address_prefecture_kana = getPrefectureKana(
    state.params.office_address_prefecture
  );

  // CCUS現場IDを取得していれば格納する
  if (
    state.ccus_field_data.ccus_field_id !== undefined &&
    state.ccus_field_data.ccus_field_id !== null
  ) {
    state.params.ccus_site_id = state.ccus_field_data.ccus_field_id;
  }
};

/**
 * 都道府県名から都道府県カナを取得する
 * @param {string}prefectureName
 * @return {string}都道府県カナ
 */
const getPrefectureKana = prefectureName => {
  let _prefecture = _.filter(
    _.flatten(
      _.map(PREFECTURE_GROUPS, region => {
        return _.values(region.prefectures);
      })
    ),
    prefecture => {
      return prefecture.name === prefectureName;
    }
  )[0];
  return _prefecture.kana;
};

/**
 * プロパティの値がなければnullを返す
 * @param {Object}params: 値がある確認したいオブジェクト
 * @param {string}key: オブジェクトのプロパティ名
 * @return {any}: プロパティの値 or null
 */
const getPropertyValue = (params, key) => {
  return _.has(params, key) ? params[key] : null;
};

/**
 * 現場登録・編集画面で利用するビジネスロジック格納クラス
 * */
const FieldService = {
  getPrefectureKana,
  getPropertyValue,
  createRegisterParams,
};

export default FieldService;



// WEBPACK FOOTER //
// ./src/services/field/FieldService.js